<div class="cso-panel">
  <mat-dialog-content class="mat-typography">
    <div class="cso-header">
      <div>
        <span class="cso-header-title">{{
          'CsO.SelectOrganization' | translate
        }}</span>
      </div>
      <div class="cso-search-container">
        <span
          class="cso-button cso-search-button"
          siteUsageTracker
          [logCategory]="'CsoChooser'"
          [logName]="'searchOrganizations'"
          (click)="searchOrganizations()"
          >{{ 'CsO.SearchAll' | translate }}</span
        >
        <input
          class="cso-search-input"
          [ngModel]="searchText"
          (keydown.enter)="searchOrganizations()"
          (ngModelChange)="searchTextChanged($event)"
          placeholder="{{ 'CsO.SearchOrganizationsPlaceholder' | translate }}"
          type="text"
          title="{{ 'CsO.SearchOrganizationsTitle' | translate }}"
        />
      </div>
    </div>

    <div class="cso-parent-tree-header">
      <span class="cso-tree-header-title">{{
        'CsO.OrganizationTree' | translate
      }}</span>
      <span
        ><mat-slide-toggle [(ngModel)]="showAll" *ngIf="isSearchMode"
          >Show all Organizations</mat-slide-toggle
        ></span
      >
      <div class="cso-select-button-top">
        <span
          class="cso-button cso-select-button"
          (click)="updateUserAndClose()"
          >{{ 'CsO.Select' | translate }}</span
        >
      </div>
    </div>

    <div class="cso-body">
      <div [ngClass]="this.isSearchMode === true ? 'cso-hidden' : ''">
        <div class="cso-drilldown-wrap">
          <!--Parent Organization Tree-->
          <div class="cso-drilldown">
            <div
              *ngFor="let org of parentOrganizationTree"
              class="cso-org-row"
              siteUsageTracker
              [logCategory]="'CsoChooser'"
              [logName]="'parentOrganiztionListItem'"
              (click)="selectParentOrganization(org.organizationID)"
              (dblclick)="dblclickParentOrganization(org.organizationID)"
              id="#cso-parent"
              [ngClass]="
                org.organizationID === this.selectedOrganizationId
                  ? 'cso-selected'
                  : ''
              "
            >
              <span class="cso-org-row-text">{{ org.organizationName }}</span>
            </div>
          </div>
        </div>

        <!-- Child Organization Tree-->
        <div id="ChildOrgTree" class="cso-tree-wrap">
          <div class="cso-tree">
            <div
              class="cso-az-filter"
              [ngClass]="this.showAlphaTab === true ? '' : 'cso-hidden'"
            >
              <div
                class="cso-az-filter-item"
                siteUsageTracker
                [logCategory]="'CsoChooser'"
                [logName]="'scrollToElementByFirstLetterA'"
                (click)="scrollToElementByFirstLetter('A')"
              >
                A-F
              </div>
              <div
                class="cso-az-filter-item"
                siteUsageTracker
                [logCategory]="'CsoChooser'"
                [logName]="'scrollToElementByFirstLetterG'"
                (click)="scrollToElementByFirstLetter('G')"
              >
                G-L
              </div>
              <div
                class="cso-az-filter-item"
                siteUsageTracker
                [logCategory]="'CsoChooser'"
                [logName]="'scrollToElementByFirstLetterM'"
                (click)="scrollToElementByFirstLetter('M')"
              >
                M-R
              </div>
              <div
                class="cso-az-filter-item"
                siteUsageTracker
                [logCategory]="'CsoChooser'"
                [logName]="'scrollToElementByFirstLetterS'"
                (click)="scrollToElementByFirstLetter('S')"
              >
                S-U
              </div>
              <div
                class="cso-az-filter-item"
                siteUsageTracker
                [logCategory]="'CsoChooser'"
                [logName]="'scrollToElementByFirstLetterV'"
                (click)="scrollToElementByFirstLetter('V')"
              >
                V-Z
              </div>
            </div>

            <div
              [ngClass]="
                this.noChildMatches === true ? 'cso-no-matches' : 'cso-hidden'
              "
            >
              {{ 'CsO.NoMatches' | translate }}
            </div>
            <div
              class="cso-org-list-wrap"
              [ngClass]="this.noChildMatches === true ? 'cso-hidden' : ''"
            >
              <div
                *ngFor="let org of childOrganizationList"
                class="cso-org-row cso-child"
                siteUsageTracker
                [logCategory]="'CsoChooser'"
                [logName]="'setSelectedOrganization'"
                (click)="setSelectedOrganization(org.organizationID)"
                (dblclick)="updateUserAndClose()"
                attr.data-orgname="{{ org.organizationName }}"
                [ngClass]="{
                  'cso-selected':
                    org.organizationID === this.selectedOrganizationId,
                  'cso-hidden': !visibleOrgIds.has(org.organizationID)
                }"
              >
                <span class="cso-org-row-text">{{ org.organizationName }}</span>
                <i
                  class="fa fa-plus-square"
                  [ngClass]="org.childCount === 0 ? 'cso-hidden' : ''"
                  siteUsageTracker
                  [logCategory]="'CsoChooser'"
                  [logName]="'changeSelectedOrganization'"
                  (click)="changeSelectedOrganization(org.organizationID, true)"
                  title="{{ 'CsO.ViewChildOrganizationsTitle' | translate }}"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Search Results -->
      <div
        class="cso-search-wrap"
        [ngClass]="this.isSearchMode === true ? '' : 'cso-hidden'"
      >
        <div
          [ngClass]="
            this.noSearchMatches === true ? 'cso-no-matches' : 'cso-hidden'
          "
        >
          {{ 'CsO.NoResults' | translate }}
        </div>
        <div
          class="cso-search"
          [ngClass]="this.noSearchMatches === true ? 'cso-hidden' : ''"
        >
          <span
            class="backToOrg"
            siteUsageTracker
            [logCategory]="'CsoChooser'"
            [logName]="'backToOrgList'"
            (click)="backToOrgList()"
            >{{ 'CsO.BackToOrgList' | translate }}</span
          >
          <ul style="margin-top: 5px">
            <li
              *ngFor="let org of csoSearchResults"
              siteUsageTracker
              [logCategory]="'CsoChooser'"
              [logName]="'selectParentOrganization'"
              (click)="selectParentOrganization(org.organizationID)"
            >
              <span
                *ngFor="let name of org.orgTreeDisplayText; let last = last"
              >
                <ng-container *ngIf="showAll || !hiddenOrgs.includes(name)">
                  <ng-container *ngIf="!last; else lastInLine">
                    {{ name }}
                  </ng-container>
                  <ng-template #lastInLine>
                    <span
                      [appHighlightSearch]="name"
                      [searchTerm]="searchText"
                      [highlightClass]="'cso-highlighted-text'"
                    ></span>
                  </ng-template>
                  <ng-container *ngIf="!last"> > </ng-container>
                </ng-container>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="cso-footer">
      <span
        class="cso-button cso-select-button mat-stroked-button"
        siteUsageTracker
        [logCategory]="'CsoChooser'"
        [logName]="'updateUserAndClose'"
        (click)="updateUserAndClose()"
        >{{ 'CsO.Select' | translate }}</span
      >
    </div>
  </mat-dialog-content>
</div>
